import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/mock';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const { language, toggleLanguage } = useLanguage();
  const t = translations[language];
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const navItems = [
    { id: 'project', label: t.nav.project },
    { id: 'renders', label: t.nav.renders },
    { id: 'floor-plans', label: language === 'es' ? 'Planos' : 'Plans' },
    { id: 'current-state', label: t.nav.currentState },
    { id: 'location', label: t.nav.location },
    { id: 'estepona', label: t.nav.estepona },
    { id: 'contact', label: t.nav.contact }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <button
            onClick={() => scrollToSection('hero')}
            className={`font-serif text-xl tracking-wider transition-colors ${
              isScrolled ? 'text-stone-800' : 'text-white'
            }`}
          >
            PAPUECAS 24
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`text-sm tracking-wide transition-colors hover:opacity-70 ${
                  isScrolled ? 'text-stone-600' : 'text-white/90'
                }`}
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* Language Toggle & Mobile Menu */}
          <div className="flex items-center space-x-4">
            <button
              onClick={toggleLanguage}
              className={`text-sm font-medium px-3 py-1.5 rounded-full border transition-all ${
                isScrolled
                  ? 'border-stone-300 text-stone-600 hover:bg-stone-100'
                  : 'border-white/30 text-white hover:bg-white/10'
              }`}
            >
              {language === 'es' ? 'EN' : 'ES'}
            </button>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`lg:hidden p-2 transition-colors ${
                isScrolled ? 'text-stone-800' : 'text-white'
              }`}
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 pt-4 bg-white/95 backdrop-blur-md -mx-6 px-6 shadow-lg">
            <div className="flex flex-col space-y-3">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-left text-sm tracking-wide py-2 transition-colors text-stone-700 hover:text-amber-700"
                >
                  {item.label}
                </button>
              ))}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
